var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"shortkey",rawName:"v-shortkey.push",value:({ ctrl: ['ctrl'], alt: ['alt'] }),expression:"{ ctrl: ['ctrl'], alt: ['alt'] }",modifiers:{"push":true}}],on:{"shortkey":_vm.displayShortcuts}})}
var staticRenderFns = []

export { render, staticRenderFns }